import { type FragmentType, useFragment } from '@/gql/codegen';
import { graphql } from '@/gql/codegen/gql';
import { ProgressBar } from '@/routes/_embaUserLayout/-components/ProgressBar';
import { Link } from '@tanstack/react-router';
import classNames from 'classnames';
import type React from 'react';
import styles from './index.module.scss';

export const ENDED_ENROLLMENT_COURSE_CARD = graphql(/* GraphQL */ `
  fragment EndedEnrollmentCourseCard on UserEnrollmentCourse {
    id
    status
    statusText
    embaCourse {
      id
      name
      thumbnailImageUrl
    }
    attendances {
      id
      attendedCountText
      progress
      status
      certificate {
        fileRedirectUrl
      }
    }
  }
`);

export type EndedEnrollmentCourseCardProps = {
  course: FragmentType<typeof ENDED_ENROLLMENT_COURSE_CARD>;
};

export const EndedEnrollmentCourseCard: React.FC<
  EndedEnrollmentCourseCardProps
> = ({ course }) => {
  const enrollmentCourse = useFragment(ENDED_ENROLLMENT_COURSE_CARD, course);

  return (
    <li className={styles.enrollmentCourse}>
      <div className={styles.courseInfo}>
        <h3>
          {enrollmentCourse.status === 'completed' && (
            <span className={styles.completedStatusIcon}>
              {enrollmentCourse.statusText}
            </span>
          )}

          <p className={styles.courseTitle}>
            {enrollmentCourse.embaCourse.name}
          </p>
        </h3>
        <div className={styles.attendanceArea}>
          <span className={styles.courseImageArea}>
            <img src={enrollmentCourse.embaCourse.thumbnailImageUrl} alt="" />
          </span>
          <ul className={styles.attendances}>
            {enrollmentCourse.attendances.map((attendance) => (
              <li key={attendance.id}>
                <div className={styles.progress}>
                  <p className={styles.attendedCount}>
                    {attendance.attendedCountText}
                  </p>
                  <ProgressBar progress={attendance.progress} />
                </div>
                <div className={styles.linkArea}>
                  <Link
                    to={attendance.certificate?.fileRedirectUrl}
                    target="_blank"
                    className={classNames(styles.actionLinkButton, {
                      [styles.disabled]: !attendance.certificate,
                    })}
                    disabled={!attendance.certificate}
                  >
                    修了証を見る
                  </Link>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </li>
  );
};
